import React from "react"

const Courses = () => {
  return <h2>Courses</h2>
}
export default Courses